import { h, JSX, FunctionalComponent } from 'preact';
type Icon = {
  className?: string;
  svgAttrs?: JSX.SVGAttributes<any>;
} & Partial<JSX.CSSProperties>;
const defaultStyle = {
  width: '24px',
  height: '24px',
  display: 'flex'
};

const SvgIcon = (props: JSX.SVGAttributes<any>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}><path fill="currentColor" fill-rule="evenodd" d="M3.81818182 6c0-1.2049091.97690908-2.18181818 2.18181818-2.18181818S8.1818182 4.7950909 8.1818182 6 7.2049091 8.1818182 6 8.1818182 3.81818182 7.2049091 3.81818182 6ZM12 7.0909091V4.9090909l-1.5763636-.2956364c-.0823637-.264-.1903637-.5170909-.3169091-.75872723l.9070909-1.326L9.4712727.98618182l-1.326.90709091c-.2416363-.12654546-.4947272-.23454546-.7587272-.31690909L7.0909091 0H4.9090909l-.2956364 1.57636364c-.264.08236363-.5170909.19036363-.75872723.31690909l-1.326-.90709091L.98618182 2.52872727l.90709091 1.326c-.12654546.24163633-.23454546.49472723-.31690909.75872723L0 4.9090909v2.1818182l1.57636364.2956364c.08236363.264.19036363.5170909.31690909.7587272l-.90709091 1.326 1.54254545 1.5425455 1.326-.9070909c.24163633.1265454.49472723.2345454.75872723.3169091L4.9090909 12h2.1818182l.2956364-1.5763636c.264-.0823637.5170909-.1903637.7587272-.3169091l1.326.9070909 1.5425455-1.5425455-.9070909-1.326c.1265454-.2416363.2345454-.4947272.3169091-.7587272L12 7.0909091Z" /></svg>;

export const GearIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: '100%',
    height: '100%'
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => <span className={className} style={{ ...defaultStyle,
  ...styles
}}><SvgIcon {...svgAttrs} /></span>;